import { useMemo } from 'react';

export const getMergedClassNames = (arr: unknown[]) => {
  return arr.filter((el) => Boolean(el)).join(' ');
};

export const useMergedClassNames = (arr: unknown[]) => {
  return useMemo(() => {
    return arr.filter((el) => Boolean(el)).join(' ');
  }, [arr]);
};

export const getUniqueKey = () => {
  const atual = window.sessionStorage.getItem('chaveAtual')
    ? parseInt(window.sessionStorage.getItem('chaveAtual') || '1')
    : 1;
  window.sessionStorage.setItem('chaveAtual', String(atual + 1));
  return `_${atual}`;
};

export const isMobile = () => {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
};

export const isiPhone = () => {
  const toMatch = [/iPhone/i, /iPad/i, /iPod/i];

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
};

export const getIdProgramaFromHash = (hash: string) => {
  // eslint-disable-next-line no-undef
  return String(atob(hash)).replace(/^(\d+)(\/{1})(.+)$/, '$1');
};

export const getIdTurmaFromHash = (hash: string) => {
  // eslint-disable-next-line no-undef
  return String(atob(hash)).replace(/^(\d+)(\/{1})(.+)$/, '$3');
};

export class TimeOut {
  pause: () => void;
  resume: () => void;
  constructor(callback: () => void, delay?: number) {
    let timerId: number;
    let start = Date.now();
    let remaining = delay;

    this.pause = function () {
      window.clearTimeout(timerId);
      remaining = (remaining ?? 0) - Date.now() - start;
    };

    this.resume = function () {
      start = Date.now();
      window.clearTimeout(timerId);
      timerId = window.setTimeout(callback, remaining);
    };

    this.resume();
  }
}

export class Interval {
  status: boolean;
  pause: () => void;
  restart: () => void;
  constructor(callback: () => void, delay?: number) {
    let intervalId: number;
    let timeoutId: number;
    let start: number;
    let remaining = delay;
    this.status = false;

    this.pause = () => {
      this.status = false;
      window.clearTimeout(timeoutId);
      window.clearInterval(intervalId);
      remaining = (delay ?? 0) - (Date.now() - start);
    };

    this.restart = () => {
      remaining = delay;
      this.resume();
    };

    this.resume = () => {
      this.status = true;
      start = Date.now();
      window.clearInterval(intervalId);
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => {
        callback();
        start = Date.now();
        intervalId = window.setInterval(() => {
          callback();
          start = Date.now();
        }, delay);
      }, remaining);
    };

    this.resume();
  }
  resume() {
    throw new Error('Method not implemented.');
  }
}

export const dispatchToAllYouTubeVideos = (
  command: 'pauseVideo' | 'stopVideo' | 'playVideo',
  idToExclude?: string
) => {
  const iframes = document.querySelectorAll('iframe');
  Array.from(iframes).forEach((f: HTMLIFrameElement) => {
    if (
      (!idToExclude || f.id !== idToExclude) &&
      typeof f.contentWindow?.postMessage === `function`
    ) {
      f.contentWindow?.postMessage(
        JSON.stringify({ event: 'command', func: command, args: '' }),
        '*'
      );
    }
  });
};

export const dispatchToYoutubeVideo = (
  command: 'pauseVideo' | 'stopVideo' | 'playVideo',
  id?: string
) => {
  const frame = document.querySelector(`#${id}`) as HTMLIFrameElement;
  if (frame) {
    frame.contentWindow?.postMessage(
      JSON.stringify({ event: 'command', func: command, args: '' }),
      '*'
    );
  }
};

export const getParentScrollableElements = (anchor?: HTMLElement | null) => {
  const arr: HTMLElement[] = [];
  if (!anchor) return arr;
  let aux = anchor;
  while (anchor.id !== 'root' && aux.parentElement) {
    if (aux.scrollHeight > aux.clientHeight) {
      arr.push(aux);
    }
    aux = aux.parentElement;
  }
  return arr;
};

export const getParents = (anchor?: HTMLElement | null): HTMLElement[] => {
  if (!anchor) return [];
  if (anchor.id === 'root' || !anchor?.parentElement) {
    return [anchor];
  }
  return [anchor, ...getParents(anchor.parentElement)];
};

export const objectKeysFiltered = <Type>(
  obj: Type,
  keysToExclude: (keyof Type)[]
): Type => {
  const p = { ...obj } as Partial<Type>;
  for (const k of keysToExclude) {
    delete p[k];
  }
  return p as Type;
};
